var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cenNav"},[_c('div',{staticClass:"cenNavBox"},[_c('div',{staticClass:"swiper-nav"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide swiper-slide-Two",style:({
						width:!item.name?'0':'auto'
					})},[_c('div',{staticClass:"cenNavBoxFor",class:_vm.current==index?'xz':'wxz',style:({
						width:!item.name?'0':'auto'
					}),on:{"click":function($event){$event.stopPropagation();return _vm.goScroll(item,index)}}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t")])])}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }